<template>
  <div v-if="cliente">
    <full-loading v-if="carregando" message="Obtendo informações..."></full-loading>
    <section id="content">
      <div class="container">
        <div class="row actions">
          <div class="col l12 s12 m4 mb2 flex">
            <button class="waves-effect waves-light btn print btn-mobile" @click="voltar()">
              <i class="material-icons left">arrow_back</i>
              Voltar
            </button>
            <div style="flex: 1"></div>
            <a v-if="cliente.pessoa.pessoa_celular" :href="`https://wa.me/55${cliente.pessoa.pessoa_celular}?text=Ol%C3%A1%2C%20segue%20relat%C3%B3rio%20que%20retrata%20a%20sua%20atual%20necessidade%20de%20cobertura.`" target="_blank">
              <button class="waves-effect waves-light btn print btn-mobile">
                <i class="material-icons right">smartphone</i>
                WhatsApp
              </button>
            </a>
            <!-- <button ref="salvar" class="waves-effect waves-light btn print btn-mobile" @click="visualizarRelatorio(true)">
              <i class="material-icons right">save</i>
              Gerar PDF
            </button> -->
            <button :disabled="!cliente.pessoa.pessoa_email" class="waves-effect waves-light btn print btn-mobile" @click="enviarEmail()">
              <i class="material-icons right">email</i>
              Enviar email
            </button>

            <button @click="relatorioContabil()" class="waves-effect waves-light btn print btn-mobile" v-if="tglContabil">
                <i class="material-icons right">insert_chart</i>
                Relatório Contábil
            </button>
            <button :disabled="carregando" class="waves-effect waves-light btn print btn-mobile" @click="visualizarRelatorio()">
              <i class="material-icons right">print</i>
               Gerar PDF
            </button>

          </div>
          <!-- <div class="col l2 s12 m3">

          </div>-->
        </div>
        <div class="card-panel p5">
          <!-- HEADER -->
          <canvas id="canvas" width="500" hidden></canvas>
          <div class="container" ref="header">
            <div class="row flag">

              <table id="table">
                <tr class="slots">
                  <td class="logo">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyBAMAAADsEZWCAAAAIVBMVEVHcEz///////////////////////////////////////+PBM77AAAACnRSTlMA+1RZ+lP8Wip3xwmx3QAAAMBJREFUOMvt0TEOwjAMBdAvUCVg7MjU3iDn6NwbdGDlClyCmS4dfEqcqHVcO5FYYCKjX9OfLwP+UDr4ugBjTZqhJj3NZeErU1lGWoKTYwAOV2rhpG9TSuekGZZ7TIET7nGLKS6aE2iOKaUe0bpiD/7fBBcTE/gNYSfSI71bi/RI3yjJPWRFrgePLvQSUT2MqB57UT2MbD3WURbp4UR6WMk9rOR9GFHVjTzWfeTRJme+sh9JzjPU5ISa4EfiRn/5QN4y+j3PvCogpgAAAABJRU5ErkJggg==" alt="">
                    Plano <br>de Ação
                  </td>
                  <td>
                    <table>
                      <tr><td class="title">Dados do Cliente</td></tr>
                      <tr>
                        <td>Nome:<b> {{cliente.pessoa.pessoa_nome}}</b></td>
                      </tr>
                      <tr v-if="cliente.pessoa.pessoa_email">
                        <td>Email:<b> {{cliente.pessoa.pessoa_email}}</b></td>
                      </tr>
                      <tr v-if="cliente.pessoa.pessoa_data_nascimento">
                        <td>Idade:<b> {{this.idade(cliente.pessoa.pessoa_data_nascimento)}} anos</b></td>
                      </tr>
                      <tr v-if="cliente.pessoa.pessoa_cpf">
                        <td>CPF:<b> {{this.formatcpf(cliente.pessoa.pessoa_cpf)}}</b></td>
                      </tr>
                      <tr v-if="cliente.pessoa.pessoa_celular">
                        <td>Telefone:<b> {{this.formattel(cliente.pessoa.pessoa_celular)}}</b></td>
                      </tr>

                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- END HEADER -->

          <div class="container">
            <div class="row">
                <!-- isso é a introdução -->
              <patrimonio-total class="lista" ref="patrimonio" :empresa_selecionada.sync="empresa_selecionada" :cliente="cliente" />
            </div>
          </div>

          <div class="conteiner" v-if="cliente.patrimonio && empresa_selecionada.empresa_id">
              <sucessao-patrimonial class="lista" ref="sucessao" :empresa_selecionada.sync="empresa_selecionada"
              :cliente="cliente" />
          </div>

          <div class="container" v-if="cliente.obrigacao_financeira">
            <div class="row">
              <obrigacoes-financeiras ref="obrigacoes" :cliente="cliente" />
            </div>
          </div>

           <div class="container" v-if="cliente.padrao_vida">
            <div class="row">
              <padrao-vida ref="padrao" :cliente="cliente" />
            </div>
          </div>

          <!-- <div class="container">
            <div class="row">
              <responsabilidade ref="responsabilidade" v-show="$refs.responsabilidade && $refs.responsabilidade.db.length > 0"/>
            </div>
          </div> -->

          <div class="container" v-if="cliente.educacao_filhos.length">
            <div class="row">
              <educacao-filhos ref="educacaofilhos" :empresa_selecionada.sync="empresa_selecionada"
              :cliente="cliente" :resumo="resumo" />
            </div>
          </div>

          <div class="container">
            <div class="row">
              <fonte-renda ref="fonte_renda" :cliente="cliente" v-show="$refs.fonte_renda && $refs.fonte_renda.db.length > 0"/>
            </div>
          </div>


          <div class="container" v-if="cliente && resumo && !resumo.zerado && empresa_selecionada.empresa_id">
            <div class="row">
              <resumo-protecao
                :cliente="cliente"
                :resumo="resumo"
                ref="resumo_protecao"
                :empresa_selecionada.sync="empresa_selecionada" />
            </div>
          </div>

          <div class="container" v-if="cliente">
            <div class="row">
              <projetos-futuros ref="projetos_futuros" :cliente="cliente" :empresa_selecionada.sync="empresa_selecionada" />
            </div>
          </div>

          <div class="container" v-if="empresa_selecionada.empresa_id && cliente.independencia_financeira && cliente.independencia_financeira.necessidade_investimento > 0">
            <div class="row">
              <liberdade-financeira
                ref="liberdade_financeira"
                :cliente="cliente"
                :empresa.sync="empresa_selecionada"/>
            </div>
          </div>


          <div class="container" v-if="cliente.projetos && cliente.projetos.length">
            <div class="row">
              <resumo-investimentos ref="resumo_investimentos" :cliente="cliente" :empresa_selecionada.sync="empresa_selecionada"/>
            </div>
          </div>

          <div class="container" v-if="cliente">
            <div class="row">
              <responsabilidade-civil :cliente="cliente" ref="responsabilidade_civil"/>
            </div>
          </div>


          <div class="container" v-if="cliente.contribuicao_previdencia_privada && cliente.contribuicao_previdencia_privada.rendimento_tributavel_total > 0">
            <div class="row">
              <incentivo-fiscal :cliente="cliente" ref="incentivo_fiscal" />
            </div>
          </div>

          <div class="container" v-if="empresa_selecionada.empresa_id">
            <div class="row">
              <perfil-investidor ref="perfil_investidor" :cliente="cliente" :empresa.sync="empresa_selecionada" />
            </div>
          </div>

          <div class="container" v-if="empresa_selecionada.empresa_id">
            <div class="row">
              <texto-final :empresas="[this.empresa_principal, ...empresasParceiras]" ref="texto_final" :empresa_selecionada.sync="empresa_selecionada" />
            </div>
          </div>

        </div>
      </div>
    </section>

    <modal title="Deseja selecionar empresa parceira?" :is-active.sync="modal.selecionar_empresa" @closed="fecharModalLogoEmpresa">
      <form  @submit.prevent="_gerarRelatorio()">
          <div>
              <div v-if="usar_empresa_parceira">
                  <ul class="select-empresas">
                    <li @click="() => empresa_selecionada = empresa"
                        :class="{active: empresa_selecionada.empresa_id === empresa.empresa_id}"
                        v-for="empresa in empresasParceiras"
                        :key="`empresa-${empresa.empresa_id}`">
                      <img :src="empresa.url_logo" width="100" style="object-fit:contain;"> {{ empresa.empresa_nome_fantasia }}
                    </li>
                  </ul>

                  <div class="right-align">
                    <button class="btn btn-default" :disabled="empresa_selecionada === empresa_principal">Continuar</button>
                  </div>
              </div>
              <div style="text-align: center" v-else>
                  <button class='btn btn-outlined' type="submit" @click="() => empresa_selecionada = empresa_principal">
                    Não
                  </button>
                  <button
                    class="btn btn-default"
                    type="button"
                    id="btn-selecionar-empresa-parceira"
                    @click="() => usar_empresa_parceira = true">
                    Sim
                  </button>
              </div>
          </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {  getUrl, api } from "@/helpers/api";
import { utils } from "./mixins";
import { relatorio } from "./mixins/relatorio";
import PatrimonioTotal from "../graficos-simulador/PatrimonioTotal";
import SucessaoPatrimonial from "../graficos-simulador/SucessaoPatrimonial";
import ObrigacoesFinanceiras from "../graficos-simulador/ObrigacoesFinanceiras";
import PadraoVida from "../graficos-simulador/PadraoVida";
import EducacaoFilhos from "../graficos-simulador/EducacaoFilhos";
import NecessidadeCoberturaAtual from "../graficos-simulador/NecessidadeCoberturaAtual";
import Projetos from "../graficos-simulador/Projetos";
import ProjetosFuturos from "../graficos-simulador/ProjetosFuturos"
// import Aposentadoria from "../graficos-simulador/Aposentadoria";
import FonteRenda from "../graficos-simulador/FonteRenda";
import ResumoProtecao from "../graficos-simulador/ResumoProtecao"
import ResumoInvestimentos from "../graficos-simulador/ResumoInvestimentos"
import LiberdadeFinanceira from "../graficos-simulador/LiberdadeFinanceira"
import ResponsabilidadeCivil from "../graficos-simulador/ResponsabilidadeCivil"
import IncentivoFiscal from "../graficos-simulador/IncentivoFiscal"
import PerfilInvestidor from "../graficos-simulador/PerfilInvestidor"
import TextoFinal from "../graficos-simulador/TextoFinal"
import FullLoading from '@/components/common/FullLoading';
import Modal from '@/components/common/Modal/Base.vue'

import Saudacao from "@/components/graficos-simulador/Saudacao.vue";
import modal from "@/helpers/wm-modal";

import Auth from '@/store/auth';

export default {
  name: "RelatorioSimulador",
  mixins: [utils, relatorio],
  components: {
    PatrimonioTotal,
    SucessaoPatrimonial,
    ObrigacoesFinanceiras,
    PadraoVida,
    EducacaoFilhos,
    NecessidadeCoberturaAtual,
    Projetos,
    ProjetosFuturos,
    // Aposentadoria,
    FonteRenda,
    ResumoProtecao,
    ResumoInvestimentos,
    LiberdadeFinanceira,
    ResponsabilidadeCivil,
    TextoFinal,
    FullLoading,
    IncentivoFiscal,
    PerfilInvestidor,

    Saudacao,
    Modal,
  },


  computed: {

    tglContabil() {

      const nome = this.empresa_principal.empresa_nome_fantasia.toLowerCase().replace(/\s+/g, ' ').trim();

      return ['xtgl contábil', 'xtgl contabil'].some(item => nome.includes(item))
    },

    usuario() {
        return Auth.state.user;
    },
    funcionarioLogado() {
      return Auth.state.user.pessoa.funcionario;
    },

    empresasParceiras() {
      return this.funcionarioLogado.empresas.filter( e => e.empresa_tipo_id != 1);
    }
  },
  data() {
    return {
      cliente: null,
      resumo: null,


      datas: [],
      sucessao: null,
      patrimonio: null,
      padrao_vida: null,
      necessidade: null,
      necessidade_atual: null,
      projeto: null,

      html: null,
      ref_patrimonio: null,
      resumo_protecao: null,
      projetos_futuros: null,
      libertade_financeira: null,
      resumo_investimentos: null,
      texto_final: null,
      carregando: true,
      empresa_selecionada: {},
      empresa_principal: null,
      usar_empresa_parceira: false,

      modal: {
          selecionar_empresa: false,
      }
    };
  },

  methods: {
    voltar() {
      let { id } = this.$route.params;
      this.$router.push({ name: "cliente_simulador", params: { id: id } });
    },

    async init() {

      this.carregando = true

      const { id } = this.$route.params;

      const {data: {result: { data: cliente }}} = await api.get(`cliente/${id}`);
      const { data: { result: { data: resumo } } } = await api.get(`resumo/${id}`);

      this.cliente = cliente;
      this.resumo  = resumo

      this.carregando = false

      this.patrimonio = cliente.patrimonio;
      this.padrao_vida = cliente.padrao_vida;
      this.projeto = cliente.projeto;

      return await cliente.pessoa;
  },

    async enviarEmail(){
      // const relatorio = await this.relatorioRender()
      const relatorio = await this.emailRelatorio()

      const email = this.html.pessoa_email

      const nome = this.html.pessoa_nome

      this.carregando = true

      let empresa_id;

      if (this.empresa_selecionada !== this.empresa_principal) {
          empresa_id = this.empresa_selecionada.empresa_id;
      }


      try {


        let { id } = this.$route.params;

        await api.post(`cliente/email-relatorio/${id}`, {email, nome, relatorio, empresa_id})
        modal.alert({title: "Enviado com Sucesso!", text: "E-mail enviado com sucesso!"})
      } finally {
        this.carregando = false
      }
    },


    async relatorioContabil() {

        this.carregando = true;

        let blob;

        let empresa_id;

        if (this.empresa_selecionada !== this.empresa_principal) {
            empresa_id = this.empresa_selecionada.empresa_id;
        }

        try{
            ({data: blob} = await api.get(`cliente/${this.$route.params.id}/relatorio-contabil`, {responseType: 'blob'}));
        } finally{
            this.carregando = false
        }

        const a = document.createElement('a');

        a.href = URL.createObjectURL(blob)

        const slug = this.cliente.pessoa.pessoa_nome.replace(/\s+/g, '_');

        a.download = `relatorio-contabil-${moment().format('DD-MM-YYYY')}-${slug}.pdf`

        a.click()
    },


    visualizarRelatorio() {

      if (this.funcionarioLogado.empresas.length > 1) {
        return this.modal.selecionar_empresa = true;
      }

      this._gerarRelatorio();

    },

    async _gerarRelatorio() {

      const { id } = this.$route.params;

      this.carregando = true;

      const relatorio = await this.emailRelatorio()

      let blob;

      let empresa_id;

      if (this.empresa_selecionada !== this.empresa_principal) {
          empresa_id = this.empresa_selecionada.empresa_id;
      }

      try{
       const {data: {url}} = await api.post(`cliente/visualizar-relatorio/${id}`, { relatorio, empresa_id });

        const a = document.createElement('a');

        a.href = url

        console.log(url)

        const slug = this.cliente.pessoa.pessoa_nome.replace(/\s+/g, '_');

        a.download = `relatorio-${moment().format('DD-MM-YYYY')}-${slug}.pdf`

        a.click()

      } finally{
        this.carregando = false
      }

      // reseta o estado do modal
      $('#modal-empresa-selecionar').modal('close');
      this.usar_empresa_parceira = false;
    //   this.empresa_selecionada = {};
    },


    fecharModalLogoEmpresa()
    {
      $('#modal-empresa-selecionar').modal('close');
      this.usar_empresa_parceira = false
      this.empresa_selecionada = this.empresa_principal;
    },
  },


  async created() {

    this.empresa_principal   = this.usuario.pessoa.funcionario.empresa;
    this.empresa_selecionada = this.empresa_principal;

    this.html = await this.init();

  }
};
</script>
<style lang="scss" scoped>
@import "./Simulador.scss";
.texto {
  margin-top: 15px;
  margin-bottom: 15px;
}
.m5 {
  margin-top: 15px;
}
.mb2{
  margin-bottom: 2%;
}

ul.select-empresas {

  border: 1px solid rgba(0, 0, 0, .15);

  li{
    display: flex;
    // justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    padding: 15px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;

    &.active{
      background-color: #e1e1e1;
    }

    img {
      height: 100px;
      width: 150px;
      flex: 0 0 auto;
      margin-right: 15px;
      border: 5px solid #fff;
      box-shadow: 0 0 1px 1px rgba(0, 0, 0, .15);
      background-color: #fff;
      object-fit: cover;
    }


    @media (max-width: 767px) {
      font-size: 16px;
      img{
        display: none;
      }
    }


  }
}


#btn-selecionar-empresa-parceira{
  @media (max-width: 767px) {
    width: 100%;
  }
}

.btn-outlined {
    background: transparent;
    border: 2px solid currentColor;
    color: var(--color-primary);
    box-shadow: none;
}


</style>


<style lang="scss" >
@import '@/assets/sass/charts.scss';
</style>



// WEBPACK FOOTER //
// src/components/relatorios/Simulador.vue